import React, { Component } from "react";
import i18n from "i18next";
import PropTypes from "prop-types";
import AppModal from "../common/modal/AppModal";

const formatUpdatedAt = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const locale = i18n.language || "tr";
  return d.toLocaleString(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Shown when a save is rejected with 409 (api/ideal-studio/training/save-state):
// this tab's baseUpdatedAt no longer matches the server's, so another
// session -- or the SCENE_LOGGING normalisation job re-saving this tab's own
// upload seconds later, a known benign false positive -- changed the
// training after this tab last loaded it. Mirrors ExitModal/
// UnsavedChangesGuardModal's layout for consistency with the app's other
// "what should happen to this save" dialogs.
export default class SaveConflictModal extends Component {
  render() {
    const { show, currentUpdatedAt, phase, onOverwrite, onReload, onCancel } = this.props;
    const busy = phase === "overwriting" || phase === "reloading";
    const when = formatUpdatedAt(currentUpdatedAt);

    const footer = (
      <div className="app-modal__footer">
        <button
          type="button"
          className="app-modal__btn app-modal__btn--ghost"
          onClick={onCancel}
          disabled={busy}
        >
          {i18n.t("saveConflict.cancel", { defaultValue: "Cancel" })}
        </button>
        <button
          type="button"
          className="app-modal__btn app-modal__btn--ghost"
          onClick={onReload}
          disabled={busy}
        >
          {phase === "reloading"
            ? i18n.t("saveConflict.reloading", { defaultValue: "Reloading…" })
            : i18n.t("saveConflict.reload", { defaultValue: "Discard my changes and reload" })}
        </button>
        <button
          type="button"
          className="app-modal__btn app-modal__btn--primary"
          onClick={onOverwrite}
          disabled={busy}
        >
          {phase === "overwriting"
            ? i18n.t("saveConflict.overwriting", { defaultValue: "Saving…" })
            : i18n.t("saveConflict.overwrite", { defaultValue: "Overwrite with my version" })}
        </button>
      </div>
    );

    return (
      <AppModal
        show={!!show}
        onClose={onCancel}
        title={i18n.t("saveConflict.title", { defaultValue: "This training changed elsewhere" })}
        size="md"
        closeButton={false}
        showSceneToggle={false}
        footer={footer}
      >
        <p>
          {i18n.t("saveConflict.body", {
            defaultValue:
              "Someone or something else saved a newer version of this training since this tab loaded it. Choose whether to keep working with your version or load the other one.",
          })}
        </p>
        {when && (
          <p style={{ color: "#6b7280", fontSize: 13 }}>
            {i18n.t("saveConflict.currentUpdatedAt", {
              defaultValue: "Other version saved at: {{when}}",
              when,
            })}
          </p>
        )}
      </AppModal>
    );
  }
}

SaveConflictModal.propTypes = {
  show: PropTypes.bool,
  currentUpdatedAt: PropTypes.string,
  phase: PropTypes.oneOf([null, "overwriting", "reloading"]),
  onOverwrite: PropTypes.func.isRequired,
  onReload: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
